import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const createRuntimeQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
      mutations: {
        retry: 0,
      },
    },
  });
};

export const RuntimeQueryProvider = ({ children }) => {
  const [queryClient] = React.useState(() => createRuntimeQueryClient());

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default RuntimeQueryProvider;